import React from "react";
import { FAMILY_TONE } from "./vocab";

export function ContextSelect({ value, onChange, options, locked = [], testId = "dl-context-select", required }) {
    const selected = value || [];
    const toggle = (id) => {
        if (locked.includes(id)) return;
        onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
    };
    return (
        <div data-testid={testId}>
            <div className="label-xs mb-1.5">Contexts{required && <span className="text-[#7C3AED] ml-1">*</span>}
                <span className="ml-2 text-white/35 normal-case tracking-normal font-normal">{selected.length ? `${selected.length} selected` : "what kind of document is this?"}</span>
            </div>
            <div className="flex flex-wrap gap-1.5">
                {options.map((c) => {
                    const on = selected.includes(c.id);
                    const tone = FAMILY_TONE[c.family] || FAMILY_TONE.other;
                    return (
                        <button type="button" key={c.id} onClick={() => toggle(c.id)} title={c.description || c.id}
                            data-testid={`${testId}-${c.id}`} aria-pressed={on} disabled={locked.includes(c.id)}
                            className={`px-2 py-1 rounded-sm border text-[11px] font-mono transition-colors ${on ? `${tone} ring-1 ring-current font-semibold shadow-[0_0_0_1px_rgba(255,255,255,0.08)]` : "border-white/10 text-white/45 hover:bg-white/5"} ${locked.includes(c.id) ? "cursor-not-allowed" : ""}`}>
                            {on ? "✓ " : ""}{c.label}
                        </button>
                    );
                })}
                {!options.length && <span className="text-[11px] text-white/40">No active contexts — add some under Settings → Data Lake contexts.</span>}
            </div>
        </div>
    );
}
